import _ from "lodash";
import { IRowData } from "components/shipment-review/types";
import { ILineItem } from "constants/order-types";
import { AllocationType } from "types/cart";
import { IBulkUnits, ILocation } from "types/cart/shipment-review";
import { BULK_UNITS_SIZE } from "constants/cart";
import { toPrecision } from "helpers/legacy-cart";

/** Checks if row allocation matches entry location */
export const isMatchLocation = (data: IRowData): boolean =>
    data.isVirtual || isAllocated(data.allocated, data.item.location); // no limitations for virtual items

/** Check is allocation type matches the provided location */
export const isAllocated = (allocated: AllocationType, location: ILocation) =>
    isAllocatedByDoor(allocated, location?.id);

export const isAllocatedByDoor = (allocated: AllocationType, door: string) =>
    (!allocated && !door) ||
    (allocated === AllocationType.ByLocation && !!door) ||
    (allocated === AllocationType.Combined && !door);

/** Returns bulk units quantity along with sized quantities and prices */
export const getBulkUnits = (li?: ILineItem, pricing?: { wholesale: number; retail: number }): IBulkUnits => {
    const data: IBulkUnits = { units: 0, sized: 0, wholesale: 0, retail: 0, unitsPerPack: 1 };
    _.forEach(li?.sizes, (x) => {
        if (x.size === BULK_UNITS_SIZE) {
            data.units = x.quantity || 0;
            data.unitsPerPack = x.__units_per_pack || 1;
            data.wholesale = toPrecision(pricing?.wholesale || 0);
            data.retail = toPrecision(pricing?.retail || 0);
        } else if (li.allocated === AllocationType.ByLocation ? !!x.location : !x.location) {
            data.sized += x.quantity || 0;
        }
    });
    return data;
};
